// extracted by mini-css-extract-plugin
module.exports = {"associationsInfo":"styles_associationsInfo__3raHS"};